module.exports = __webpack_public_path__ + "020a4fc9d69b2b0120a0af25929006b4.jpg";